import { UnknownObject } from '../types/utility-types';

export const isObject = (value: unknown): value is UnknownObject => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};

export const isEnumValue = <T extends Record<string, string | number>>(
  value: unknown,
  enumObj: T,
): value is T[keyof T] => Object.values(enumObj).includes(value as T[keyof T]);

export const isFieldsInObject = <T extends UnknownObject, K extends string[]>(
  obj: T,
  fields: readonly [...K],
): obj is T & { [P in K[number]]: unknown } => fields.every((field) => field in obj);
